export const parseZipCodes = (range) => {
    const zips = range.split('-');

    if (zips.length > 1) {
        const sizeOfRange = zips[1] - zips[0];

        if (sizeOfRange === 9999) {
            return {
                type: 'zip1',
                zips: [zips[0].substring(0, 1)]
            };
        }

        if (sizeOfRange === 999) {
            return {
                type: 'zip2',
                zips: [zips[0].substring(0, 2)]
            };
        }

        if (sizeOfRange === 99) {
            return {
                type: 'zip3',
                zips: [zips[0].substring(0, 3)]
            };
        }

        if (sizeOfRange < 99) {
            return {
                type: 'zip5',
                zips: [...[...Array(sizeOfRange).keys()].map((item, i) => parseInt(zips[0]) + i), parseInt(zips[1])]
            };
        }
    }

    return {
        type: 'zip5',
        zips: [zips[0]]
    };
};

export const parseSelectedLayers = (layers) => {
    const zipCodes = {};
    layers.postalCodes.forEach(range => {
        const zipType = parseZipCodes(range);
        zipType.zips.forEach(zip => {
            zipCodes[zipType.type] = zipCodes[zipType.type] ? [...zipCodes[zipType.type], `${zip}${zipType.type}`] : [`${zip}${zipType.type}`];
        });
    });

    return {
        aregion: [...layers.aregion.map(a => `${a.code}aregion`)],
        county: [...layers.county.map(a => `${a.code}county`)],
        postalcity: [...layers.locality.map(a => `${a}postalcity`)],
        municipality: [...layers.municipality].map(a => `${a.code}municipality`),
        ...zipCodes
    };
};

export const sortSelectedLayersInTypes = (layers) => {
    const zipCodes = {};
    layers.postalCodes.forEach(range => {
        const zipType = parseZipCodes(range);
        zipType.zips.forEach(zip => {
            zipCodes[zipType.type] = zipCodes[zipType.type] ? [...zipCodes[zipType.type], range] : [range];
        });
    });

    return {
        aregion: [...layers.aregion.map(a => a.name)],
        county: [...layers.county.map(a => a.name)],
        postalcity: [...layers.locality.map(a => a)],
        municipality: [...layers.municipality].map(a => a.name),
        ...zipCodes
    };
};